import { Trans, useTranslation } from 'next-i18next'

export interface DiftProps {}

export default function Dift() {
  const { t } = useTranslation('dift.block')

  return (
    <div className="h-auto overflow-hidden bg-black">
      <div className="relative mx-auto flex max-w-[1400px] flex-col items-center justify-center space-y-4 px-4 py-12 text-white md:flex-row md:space-x-[100px] md:space-y-0 md:px-8 md:py-20 lg:space-x-[124px]">
        <div className="flex w-full max-w-[400px] flex-col">
          <h2 className="mb-2 text-left font-default text-3.5xl font-medium leading-[48px] -tracking-[1px] md:text-left">
            {t('title')}
          </h2>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            className="-ml-[45px] max-h-[116px] max-w-[328px]"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src="/the-dift.mp4" type="video/mp4" />
          </video>
        </div>
        <pre className="mx-auto max-w-[400px] whitespace-pre-wrap text-left text-xl md:mx-[unset] md:max-w-[325px] md:text-left">
          <Trans
            t={t}
            i18nKey="definition"
            components={{
              a: <br />,
            }}
          />
        </pre>
      </div>
    </div>
  )
}
